export default __webpack_public_path__ + "static/media/export.c691e927.svg";